import BgCta from '../assets/img/bg/bg-cta.jpg';

export default function EmailService() {
  return(
    <div className="cta-area de-padding hero-bg" style={{backgroundImage:  `url(${BgCta})`}}>
    <div className="container">
      <div className="row">
        <div className="col-xl-6 offset-xl-3">
          <div className="cta-wpr text-center">
            <div className="pl mb-50">
                <i className="ti-control-play"></i>
              
            </div>
            <h2 className="heading-1 mb-50">
              New to logistics services? Need help?
            </h2>
            <div className="cta-bt">
              <a href="mailto:info@hallgord.com" className="btn-4 btn-md">
                Send Us Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}